export const screenSize = {
    small: 480,
    medium: 768,
    large: 1024,
    extraLarge: 1440,
};
